import {
  getAnupanList,
  createAnupan,
  updateAnupan,
  deleteAnupan,
  formatAnupans,
} from "../../services/AnupanService";
import {
  CONFIRMED_GET_ANUPANS,
  CONFIRMED_CREATE_ANUPAN,
  CONFIRMED_EDIT_ANUPAN,
  CONFIRMED_DELETE_ANUPAN,
} from "../types/AnupanTypes";
import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";

export function getAnupanAction(
  pagination = true,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return async (dispatch) => {
    try {
      const response = await getAnupanList(
        pagination,
        pageid,
        search_by,
        search_keyword,
        sort_by,
        sort_order
      );

      if (response?.status === 200 && response.data?.status === "success") {
        const list = formatAnupans(response.data.data);
        const num_rows = response.data.num_rows || 0;

        dispatch({
          type: CONFIRMED_GET_ANUPANS,
          payload: { list, num_rows },
        });
      } else {
        handleError("Failed to get Anupan list");
      }
    } catch (error) {
      console.error("Anupan Fetch Error:", error);
      showErrorAlert("Failed to get Anupan list");
    }
  };
}

export function createAnupanAction(anupanData, navigate) {
  return async (dispatch) => {
    try {
      const response = await createAnupan(anupanData);

      if (response?.status === 200 && response.data?.status === "success") {
        const formatted = formatAnupans([response.data.data])[0];

        dispatch({
          type: CONFIRMED_CREATE_ANUPAN,
          payload: formatted,
        });

        handleSuccess("Anupan created successfully!");
        if (navigate) navigate("/app-anupan");
      } else {
        showErrorAlert("Failed to create Anupan");
      }
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to create Anupan");
    }
  };
}

export function updateAnupanAction(anupanData, anupanaId, navigate) {
  return async (dispatch) => {
    try {
      const payload = {
        ...anupanData,
        anupana_id: anupanaId,
      };

      const response = await updateAnupan(payload);

      if (response?.status === 200 && response.data?.status === "success") {
        const formatted = formatAnupans([response.data.data])[0];

        dispatch({
          type: CONFIRMED_EDIT_ANUPAN,
          payload: formatted,
        });

        handleSuccess("Anupan updated successfully!");
        if (navigate) navigate("/app-anupan");
      } else {
        showErrorAlert("Failed to update Anupan");
      }
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to update Anupan");
    }
  };
}

export function deleteAnupanAction(anupanaId) {
  return async (dispatch) => {
    try {
      await deleteAnupan(anupanaId);
      dispatch({
        type: CONFIRMED_DELETE_ANUPAN,
        payload: { anupana_id: anupanaId },
      });
      handleSuccess("Anupan deleted successfully!");
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to delete Anupan");
    }
  };
}
